$(document).ready(function(){
  //code for showing the main images and shop by model image
  $('#imgSel').on('change', function(e){
    filterImages(e.target.value);
  });

  $('.cbtn').on('click', function(){
    window.location.href = $(this).data('url');
  });

  $('ul.select li.selected').on('click', function(){
    $('ul.select li.option').toggle();
  });
  
  $('ul.select li.option').on('click', function(){
    $('#imgSel').val($(this).data('value'));
    $('#imgSel').trigger('change');
    $('ul.select li.option').hide();
    $('ul.select li.selected').html($(this).html());
  });

  function filterImages(klass){
    if(klass=='shwoll'){
       klass = $($('#imgSel option')[1]).val();
      $('#imgSel').val(klass);
    }
    $('.product__main-photos').find('.'+klass).show();
    $('.product-main-slide:not(.'+klass+')').hide();
    $('.slkHolder').scrollLeft(0);
  }

  function defaultSelectModel(){
    if($('.site-header').is(':visible')){
      filterImages($($('#imgSel option')[1]).val());
      AOS.refresh();
    } else {
      setTimeout(function() {
        filterImages($($('#imgSel option')[1]).val());
      }, 1000);
    }
  }

  $('.all-black-section-products').slick({
    
  });

  function initSlickIfMobile() {
    $('.mobile-slider').each(function () {
      var $slider = $(this);
      var windowWidth = $(window).width();
  
      // Destroy slick if initialized
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
  
      // Re-initialize based on breakpoints
      if (windowWidth < 992) {
        let slidesToShow = windowWidth < 768 ? 1 : 3;
  
        $slider.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: true,
          arrows: true,
          infinite: true,
          centerMode: true,
          centerPadding: "15%"
        });
      }
    });
  }

  // Run on page load
  initSlickIfMobile();
  
  // Re-run on window resize (with debounce for performance)
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initSlickIfMobile, 200);
  });
  
  $('.wrap-video-slider-v').slick({
    slidesToShow: 5,
    // slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: true,
    centerPadding: "10%",
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: "10%",
          variableWidth: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: "15%",
          dots: true,
          arrows: false,
          variableWidth: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: "0%",
          dots: true,
          arrows: false,
          variableWidth: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: "0%",
          dots: true,
          arrows: false,
          variableWidth: false
        }
      }
    ]
  });

  $('.vitae-athletes-videos').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.cbtn').on('click', function(){
    window.location.href = $(this).data('url');
  });

  $('.modelselbtn').on('click', function(){
      var popupModal = new theme.Modals('dynModal', 'dyn-modal', {});
      $('#dynModal .modal__centered').html($('#modelImgSel').html());
      $('.js-modal-open-dyn-modal').click();
      
      $('#dynModal .imgholder').each(function(imgholder){
        var self = $(this);
        var trgt = self.data('trgt');
        if(trgt == $('#imgSel').val()){self.addClass('active');}
      	var cl=$($('.product__thumb-item.'+trgt)[0]).find('img').clone();
        self.prepend(cl);
      });
      
      $('#dynModal .btn').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        var imgholder = $(this).closest('.imgholder');
        var trgt = imgholder.data('trgt');
        
        $('#imgSel').val(trgt);
        $('#imgSel').trigger('change');
        $('ul.select li.option').hide();
        $('li.selected').html($('li.option[data-value="'+trgt+'"]').html());
        popupModal.close();
        $('html, body').animate({
          scrollTop: ($('.selms').offset().top-50)
        },500);

        $(".flickity-slider .product-slide-model-wrapper").removeClass("is-selected");
        $(".flickity-slider .product-slide-model-wrapper .product-main-slide." + trgt).first().closest(".product-slide-model-wrapper").addClass("is-selected");
        
      });
    });

  $('.toggleAudioBtn').on('click', function() {
    // Find the video element within the same .video-container as the button
    var video = $(this).closest('.video-container').find('video')[0];

    // Check if the video element exists
    if (video && video.tagName === 'VIDEO') {
        // Check if the video is muted (audio is off)
        if (video.muted) {
            video.muted = false;  // Unmute the video to play the audio
            $(this).find("img").attr('src', "https://cdn.shopify.com/s/files/1/2428/8283/files/sound-off-icon-40944.png?v=1746021177");  // Change button text to "Mute Audio"
        } else {
            video.muted = true;   // Mute the video to stop the audio
             $(this).find("img").attr('src', "https://cdn.shopify.com/s/files/1/2428/8283/files/material-symbols_no-sound_ea1a2ba3-a331-4977-b1a8-4b8f7dca5a10.png?v=1746189332");  // Change button text to "Play Audio"
        }
    } else {
        console.error('No valid video element found');
    }
});

  $('#wiw_section form').on('submit', function(e){
    e.preventDefault();
    var self = $(this);
    $.ajax({
      url: '/cart/add.js',      
      type: 'post',      
      data: self.children(' input[type=\'hidden\'], select'),      
      dataType: 'json',      
      beforeSend: function() { self.children('.btnsubmit').html('Adding...'); },      
      complete: function() {self.children('.btnsubmit').html("Add To Cart");},      
      success: function(json) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      },      
      error: function(xhr, ajaxOptions, thrownError) {
        const res = JSON.parse(xhr.responseText);
        if(res.message == 'Parameter Missing or Invalid'){
          alert("Please Select Size");
        }else if(res.status == '422'){
          alert(res.message);
        }else{
          alert(xhr.responseText);
        }
      }
    });
  });

  // Show description by default, hide shipping
  $('.description-block').show();
  $('.shipping-block').hide();
  $('.materials-block').hide();

  $('.tab-button').click(function () {
    var tab = $(this).data('tab');

    // Remove active class from all, add to clicked
    $('.tab-button').removeClass('active');
    $(this).addClass('active');

    // Toggle content blocks
    if (tab === 'description') {
      $('.description-block').show();
      $('.shipping-block').hide();
      $('.materials-block').hide();
    } else if (tab === 'shipping') {
      $('.shipping-block').show();
      $('.description-block').hide();
      $('.materials-block').hide();
    } else if (tab === 'materials-care') {
      $('.materials-block').show();
      $('.description-block').hide();
      $('.shipping-block').hide();
    }
  });

  $('.szchrt').on('click', function(){
    var popupModal = new theme.Modals('dynModal', 'dyn-modal', {});
    $('#dynModal .modal__centered').html($('.prodszchrt').html());
    $('#dynModal .szimg li').on('click', function(){
      $('#dynModal .szimgholder').removeClass('activ');
      $('#dynModal .szmodelimgs').removeClass('activ');
      $('#dynModal .szimg li').removeClass('active');
      $(this).addClass('active');
      $('#dynModal .szimgholder.'+$(this).data('trgt')).addClass('activ');
      $('#dynModal .szmodelimgs.'+$(this).data('trgt')).addClass('activ');
    });
    $('#dynModal .input-full').on('keyup', function(e){
      if($("#dynModal .input-full").filter(function () {
              return $.trim($(this).val()).length == 0
          }).length == 0){
          $('#dynModal .frmkls .btn').attr('disabled', false);
      } else { $('#dynModal .frmkls .btn').attr('disabled', true);}
    });
    $('.szchrtwrap .askqs').on('click', function(e){
      $('#dynModal .frmkls').toggle();
      //window.open($('#messageus_button').attr('href'), '_blank');
    });

    setTimeout(function(){
      $('.js-modal-open-dyn-modal').click();
    }, 300);
  });
  
  $('.all-black-section-content .common-btn').on('click', function(){
    var popupModal = new theme.Modals('dynModal', 'dyn-modal', {});
    $('#dynModal .modal__centered').html($('.all-black-section .all-black-section-products .inner-items.slick-slide.slick-current.slick-active.slick-center .shop-full-set').html());
    
    $('.js-modal-open-dyn-modal').click();
  });

  $(document).on('click', '.collection-filter__title', function() {
    $(this).next('ul').toggleClass('active');
  });

  $('.main-menu-wrap h3').on('click', function() {
    $(this).closest('.custom-menus, .custom-menu').toggleClass('active');
  });

  document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant;
    if (variant && variant.available) {
      window.location.href = `${window.location.pathname}?variant=${variant.id}`;
    }
  });

  // code for animation effect on product image
  document.querySelectorAll(".product-slide-model-wrapper").forEach((wrapper) => {
    const slide = wrapper.querySelector(".product-main-slide");
    const modelInfo = wrapper.querySelector(".product-model-info");
    const line1 = modelInfo.querySelector(".line-1");
    const line2 = modelInfo.querySelector(".line-2");

    if (line1 && line2) {
      const originalText1 = line1.textContent.trim();
      const originalText2 = line2.textContent.trim();
      line1.dataset.fullText = originalText1;
      line2.dataset.fullText = originalText2;

      let typing1, typing2;

      wrapper.addEventListener("mouseenter", () => {
        modelInfo.classList.add("show-info");
        line1.textContent = "";
        line2.textContent = "";
        clearTimeout(typing1);
        clearTimeout(typing2);
        typeWriter(line1, 0, originalText1.split(" "), (t) => typing1 = t);
        typeWriter(line2, 0, originalText2.split(" "), (t) => typing2 = t);
      });

      wrapper.addEventListener("mouseleave", () => {
        modelInfo.classList.remove("show-info");
        line1.textContent = "";
        line2.textContent = "";
        clearTimeout(typing1);
        clearTimeout(typing2);
      });
    }
  });

  function typeWriter(el, index, words, setTimeoutRef) {
    if (index < words.length) {
      el.textContent += (index === 0 ? "" : " ") + words[index];
      const timeout = setTimeout(() => typeWriter(el, index + 1, words, setTimeoutRef), 100);
      setTimeoutRef(timeout);
    }
  }

  // code of add toggle in colors
  $('.color-toggle').on('click', function () {
    const $container = $(this).closest('.colorbtns');
    const $hiddenColors = $container.find('.hidden-color');
    const isExpanded = !$hiddenColors.first().hasClass('hide');
  
    if (isExpanded) {
      $hiddenColors.addClass('hide');
      $(this).text('+' + $hiddenColors.length);
    } else {
      $hiddenColors.removeClass('hide');
      $(this).text('Less');
    }
  });

  //code for add product on cart from cart popup
  $('.cart-recommend-item .cart-recommend-img-wrap button').on('click', function(){
    event.preventDefault();
    var self = $(this);
    var pid = $(this).data('pid');
    $.ajax({
      url: '/cart/add.js',      
      type: 'post',      
      data: {id: pid},      
      dataType: 'json',      
      success: function(json) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      },      
      error: function(xhr, ajaxOptions, thrownError) {alert(xhr.responseText);}
    });
  });

  // code of cart popup checkboxes
  $('#gift-box-packg').on('change',function(e){
    var self = $(this);
    var pid = $(this).data('pid');
    
    if($(this).is(":checked")){
      $.ajax({   
        url: '/cart/add.js',      
        type: 'post',      
        data: {id: pid},      
        dataType: 'json',      
        success: function(json) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        },      
        error: function(xhr, ajaxOptions, thrownError) {alert(xhr.responseText);}
      });
    }else{
      $.getJSON('/cart.js', function(cart) {
        var item = cart.items.find(i => i.variant_id == pid);
        if (item) {
          $.ajax({
            url: '/cart/change.js',
            type: 'post',
            data: { id: item.key, quantity: 0 },
            dataType: 'json',
            success: function(json) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:removed'));
            },
            error: function(xhr) {
              alert(xhr.responseText);
            }
          });
        }
      });
    }
  });

  $('#insurance').on('change',function(e){
    var self = $(this);
    var pid = $(this).data('pid');
    if($(this).is(":checked")){
      $.ajax({      
        url: '/cart/add.js',      
        type: 'post',      
        data: {id: pid},      
        dataType: 'json',     
        success: function(json) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        },      
        error: function(xhr, ajaxOptions, thrownError) {alert(xhr.responseText);}
      });
    }else{
      $.getJSON('/cart.js', function(cart) {
        var item = cart.items.find(i => i.variant_id == pid);
        if (item) {
          $.ajax({
            url: '/cart/change.js',
            type: 'post',
            data: { id: item.key, quantity: 0 },
            dataType: 'json',
            success: function(json) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:removed'));
            },
            error: function(xhr) {
              alert(xhr.responseText);
            }
          });
        }
      });
    }
  });

  //code for add class on body
  $('.mobile-menu-toggle .site-nav__link').on('click', function(e) {
    e.preventDefault(); // prevents default link behavior
    $('body').toggleClass('toggle-mobile-menu');
  });

  //code for reload the page on variant click
  $(document).on('change', '.sticky-size-buy-button .variant-input-wrap input[data-variant-input]', function() {
    location.reload();
  });

  //code for adding the class on header on scroll
  function handleMobileScrollEvent() {
    if ($(window).width() < 767) {
      $(window).on('scroll.mobileScroll', function () {
        if ($(this).scrollTop() > 25) {
          $('header.site-header').addClass('sticky-mobile-header');
        } else {
          $('header.site-header').removeClass('sticky-mobile-header');
        }
      });
    } else {
      $(window).off('scroll.mobileScroll');
      $('header.site-header').removeClass('sticky-mobile-header');
    }
  }

  handleMobileScrollEvent();
  $(window).on('resize', handleScrollEvent);
});

 //code for hiding the slider dots
$(document).ready(function () {
  if ($(window).width() < 992) {
    var $sliderSection = $('.training-essentials-image-section.mobile-slider.slick-initialized.slick-slider.slick-dotted');
    if ($sliderSection.find('.slick-track').children().length === 0) {
      $sliderSection.hide(); // Hide the whole slider section
    }
  }else{
    var $sliderSection = $('.training-essentials-image-section');
    if ($sliderSection.children().length === 0) {
      $sliderSection.hide(); // Hide the whole slider section
    }
  }
});

//code for adding class on body when cart popup is open
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');

  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    const isOpen = cartDrawer.classList.contains('drawer--is-open');
    document.body.classList.toggle('cart-drawer-open', isOpen);
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class']
  });
});

//code for adding class on body when cart popup is open on iphone
document.addEventListener('DOMContentLoaded', function () {
  const isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;

  if (!isIphone) return; // Exit early if not iPhone

  const cartDrawer = document.getElementById('CartDrawer');

  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    const isOpen = cartDrawer.classList.contains('drawer--is-open');
    document.body.classList.toggle('cart-drawer-open-iphone', isOpen);
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class']
  });
});


$(document).ready(function(){
  let lastScrollTop = 0;
  $(window).on('scroll', function () {
    // Check screen width
    if ($(window).width() <= 767) {
      let currentScroll = $(this).scrollTop();
      // Check if scroll is more than 50px
      if (currentScroll > 500) {
        if (currentScroll > lastScrollTop) {
          // Scrolling Down
          $('body').addClass('header-hide').removeClass('header-show');
        } else {
          // Scrolling Up
          $('body').addClass('header-show').removeClass('header-hide');
        }
      } else {
        // Reset classes when near top
        $('body').removeClass('header-hide header-show');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    } else {
      // Optional: Reset when not in mobile view
      $('body').removeClass('header-hide header-show');
    }
  });
});

$(document).ready(function(){
  $('.quick-add-to-cart-btn').click(function(e) {
    e.preventDefault();
    jQuery(this).parents(".grid-product__content").addClass("show-cartion");
  });

  $('.sticky-variations .close-button').click(function(e) {
    e.preventDefault();
    jQuery(this).parents(".grid-product__content").removeClass("show-cartion");
  });

  $(document).on('click', '.sticky-variations .sticky-variation-span-d', function(e) {
    e.preventDefault();
  
    const button = $(this);
    const variantID = button.attr("value");
    const quantity = 1;
  
    // Prepare data
    const requestData = {
      quantity: quantity
    };
    if (variantID) {
      requestData.id = variantID;
    }
  
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: requestData,
      dataType: 'json',
      success: function(response) {
  
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(cart => {
            $('span.cart-link__bubble-num').text(cart.item_count);
            // window.location.href = '/cart';
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            // 🔁 Add this to trigger the progress bar update
            document.dispatchEvent(new Event('cart:updated'));
          })
          .catch(fetchError => {
            console.error('Error fetching cart:', fetchError);
          });
  
      },
      error: function(xhr) {
        console.error('Error adding to cart:', xhr.responseText);
  
        let message = "An unexpected error occurred.";
        if (xhr.responseText) {
          try {
            const response = JSON.parse(xhr.responseText);
            message = response.message || response.description || message;
          } catch (parseError) {
            console.error('Error parsing JSON:', parseError);
          }
        }
  
        alert(message); // Will show Shopify's error message
        button.prop('disabled', false).text('Add to Cart');
      }
    });
    return false;
  });
  // $('.variant-wrapper.small--text-center.js .size-chart, .price-buy-buttons.cstm-price-button').wrapAll('<div class="main-add-ro-cat-div"></div>');
  // jQuery(".main-add-ro-cat-div").insertAfter(".description-tab");

  if (window.innerWidth < 1024) { // Mobile check
    function limitDotsDisplay(slick, currentSlide) {
      var $dots = slick.$dots.find('li');
      var total = $dots.length;
      var visible = 5;
      var half = Math.floor(visible / 2);
      var start = Math.max(0, currentSlide - half);
      var end = Math.min(total, start + visible);
    
      // Adjust if you're near the end
      if (end - start < visible) {
        start = Math.max(0, end - visible);
      }
    
      $dots.hide().slice(start, end).show();
    }
    
    // On slide change or init
    $('.all-black-section-products').on('init reInit afterChange', function (event, slick, currentSlide) {
      limitDotsDisplay(slick, currentSlide || 0);
    });
      
      setTimeout(function() {
    $(".all-black-section ul.slick-dots li").click();
        }, 2000);
          setTimeout(function() {
            console.log("scroll");
    $(".wrap-video-slider-v ul.slick-dots li").click();
        }, 3000);
  }

  if (window.innerWidth < 767) { // Mobile check
     
    jQuery(".collection-filters").appendTo(".main-under-colleciton-m");
     
    jQuery("div.collection-filters .collection-dropdowns").appendTo(".sort-by-mobile-new");
     
    jQuery(document).on('click', '.mobile-filter', function(){
       jQuery(".coleciton-mobile-filter-new").addClass("mobile-filter-open");
    });
    jQuery(document).on('click', '.mobile-toggle-close-menu', function(){
       jQuery(".coleciton-mobile-filter-new").removeClass("mobile-filter-open");
    });
    jQuery(document).on('click', '.collection-filter__title', function(){
        jQuery(this).parents(".collection-filter__inner").toggleClass("open_menu");
    })

     jQuery(document).on('click', 'li.tag label', function(){
        jQuery("span.selected-products").text(jQuery("li.tag.tag--active").length + "selected");
    })
    jQuery("span.selected-products").text(jQuery("li.tag.tag--active").length + "selected");
     
  }

  jQuery(document).on('click', '.clear-all-filters', function (e) {
    e.preventDefault();
    e.stopPropagation(); // add this
  
    var baseUrl = window.location.origin + window.location.pathname;
    window.location.href = baseUrl;
  });

});

setTimeout(function(){
  jQuery(".product.template-product .wiw-section .swym-atw-btn-wrapper-for-img.product_image_top_right").appendTo(".product.template-product .product-section .grid .grid__item .product__photos .product__main-photos")
},2500);